
namespace GeniuzPOS.Member {

    @Serenity.Decorators.registerClass()
    export class MbReport01_DtDialog extends Serenity.Extensions.GridEditorDialog<MbReport01_DtRow> {
        protected getFormKey() { return MbReport01_DtForm.formKey; }
        protected getIdProperty() { return MbReport01_DtRow.idProperty; }
        protected getLocalTextPrefix() { return MbReport01_DtRow.localTextPrefix; }
        protected getNameProperty() { return MbReport01_DtRow.nameProperty; }
        protected getService() { return MbReport01_DtService.baseUrl; }
        // protected getDeletePermission() { return MbReport01_DtRow.deletePermission; }
        // protected getInsertPermission() { return MbReport01_DtRow.insertPermission; }
        // protected getUpdatePermission() { return MbReport01_DtRow.updatePermission; }

        protected form = new MbReport01_DtForm(this.idPrefix);
        constructor() {
            super();
            this.form = new MbReport01_DtForm(this.idPrefix);
            // (this.form.PluDtList.view as any).onDataChanged.subscribe(() => {
            // let self = this;
            // //ui-state-default slick-footerrow-column l0 r0 frozen
            // self.element.find(".ui-state-default.slick-footerrow-column.l0.r0.frozen").html("รวม");
            // });
            }

    }
}